let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e65TP")).then(() => parcelRequire('RZ5dr'));